<template>
  <div>
  
    
    <b-row >
       
  <!----- SideBar All Design List ---->
   <div class="tnaside">
     <sidebarAllDesignsComponent></sidebarAllDesignsComponent>
   </div>
  <!----- SideBar All Design List End ----> 
  
     <div class="design-container-details__main" style="width:78%" >
        <div class="brand-card" >
<!-- style="margin-top:10px;margin-bottom:10px;" -->
          <div class="col-md-12" >
            <div class="col-md-12">Design Title:<strong> &nbsp;{{style_details.design_title}}</strong> </div>
              <div class="col-md-12">Style Name : &nbsp;{{style_details.style_name}} >> {{style_details.sub_cattitle}}</div>
              <div class="col-md-12">Created Date : {{style_details.created_date }} </div>
              <div class="col-md-12">Buyer Name : {{style_details.sendqname }} </div>
          </div>

<!-- Code For Tab -->
<navbarMenu></navbarMenu>
<br>

<!-- Code For Tab Ends -->
                      <!-- <b-col sm="12"> -->
        <!-- <b-card> -->
          <b-col sm="12">
                <label><b>Vendor Name &nbsp;:</b> {{selectedvendorname}}</label>&nbsp;&nbsp;&nbsp;&nbsp;
              
                <label><b>Buyer Name&nbsp;:</b> {{selectedbuyername}}</label>&nbsp;&nbsp;&nbsp;&nbsp;
              
                <label><b>Status&nbsp;:</b> {{selectedstatus}}</label>&nbsp;&nbsp;&nbsp;&nbsp;
             </b-col>


               <ul class="nav nav-tabs">
            <li class="nav-item">
              <router-link :to="'/design_purchaseorder/'+ route_id " class="nav-link " data-toggle="pill">
               Purchase Order 
            
            </router-link>
            </li>
            <!-- <li class="nav-item">
              <router-link :to="'/fcplm_vendor/poform/' " class="nav-link " data-toggle="pill">
              Po form 
            
            </router-link>
            </li> -->
             <li class="nav-item" v-if="user_type!='Quality_Executive'" >
             <router-link :to="'/design_po_tna/'+ route_id " class="nav-link " data-toggle="pill">
              TNA   
            
            </router-link>
            </li>
            <li class="nav-item" v-if="user_type=='Quality_Executive'" >
             <router-link :to="'/qc_executive_tna/'+ route_id " class="nav-link " data-toggle="pill">
              TNA   
            
            </router-link>
            </li>
            <!-- <li class="nav-item">
             <router-link :to="'/design_po_reports/' + route_id" class="nav-link " data-toggle="pill">
              Reports   
            
            </router-link>
            </li> -->
           
             
          </ul>  
          <br><br>    
<!-- <div class="col-md-12"> -->
           
              <div class="col-md-12">
              <label style="float: left;"><b>TNA Details</b></label> 
              </div><br>
        <!-- <b-col md="12"> -->
 <!-- <div class="col-md-12"> -->
      <!-- <div class="col-md-12">   -->
         <b-row style="overflow:auto">
          <div class="col-md-12 tnapocol">
      <table class="table">
        
        <thead class="theader">
                <th>Activities</th>
                <th>Planned Date</th>
                <th>Actual Date</th>
                <th>Feedback</th>
                <th></th>
                <th colspan="2">Action</th>
                <!-- <th >Action</th> -->
        </thead>
        <tbody v-if="totalRows>0">
            <tr class="table table-hover" v-for="(items, index) in tnadata">
                <td>{{items.activities}}</td>
                <td>{{items.planned_achieve_date}}</td>
                <td>{{items.actual_achieved_date}}</td>
                <td v-if="(status_value=='feedback')"><b-form-input type="text" name="comment" placeholder="Enter Feedback" v-model="comment[index]" @change="getfeedback(index,items.activities_id,items.tna_id,comment[index])" ></b-form-input></td>
                  <td  v-if="selected_operational_status!='TNA_Feedback'">{{items.feedback}}</td >
                <td readonly v-if="selected_operational_status=='TNA_Feedback'" style="pointer-events: none;">{{items.feedback}}</td>
                
                <!-- v-if="items.actual_achieved_date!='' && items.actual_achieved_date!= null"   -->
               
                <td>
                  <button v-if="items.document!= ''"  @click="tnadownload(items.tna_id)"><i class="fa fa-download" variant="primary" aria-hidden="true" style="color: green;" ></i></button>
                </td>
                <td>
                   
                    <!-- <div v-if="selected_operational_status=='FPT submitted'|| selected_operational_status=='PP-Dispatch' || selected_operational_status=='GPT-Submitted' || selected_operational_status=='Style-Inspected' || selected_operational_status!='TNA–uploaded'">
                      <label class="radio-inline" ><input type="radio" name="tnaoptradio" value="tnaapproved" v-model="status" checked @click="achivedtnaaction('approved',items.tna_id,items.activities_id)" >&nbsp;Approve</label>&nbsp;&nbsp;
                    
          
                  <label class="radio-inline" ><input type="radio" name="tnaoptradio" value="tnarejected" v-model="status" @click="achivedtnaaction('rejected',items.tna_id,items.activities_id)" >&nbsp;Reject</label>
                </div> -->
                
                <div v-if="items.status=='approved' || items.status=='Approved' || items.status=='Actual_Approved' || items.status=='Actual_Reject' || items.status=='rejected' || items.status=='Actual_PartialApproved' || items.status=='planned_approved' || items.status=='planned_rejected'">
                  <label v-if="items.status=='approved'|| items.status=='Actual_Approved' || items.status=='Approved'">
                    <i class="fa fa-check" aria-hidden="true" style="color: #2ECC71">&nbsp;Approved</i>
                  </label>
                  <label v-if="items.status=='planned_approved'">
                    <i class="fa fa-check" aria-hidden="true" style="color: #FF8C00">&nbsp;Planned Date Approved</i>
                  </label>
                  <label v-if="items.status=='Actual_Reject' || items.status=='rejected'">
                    <i class="fa fa-close" aria-hidden="true" style="color: #E74C3C">&nbsp;Rejected</i>
                  </label>
                  <label v-if="items.status=='planned_rejected'">
                    <i class="fa fa-close" aria-hidden="true" style="color: #E74C3C">&nbsp;Planned Date Rejected</i>
                  </label>


                  <label v-if="items.status=='Actual_PartialApproved'">
                    <i class="fa fa-check" aria-hidden="true" style="color: #1082F3">&nbsp;Partially Approved</i>
                  </label>
                  
                </div>

                <div v-if="items.status=='Submitted' && items.activities!='FPT Submission' && items.activities!='PP Sample Submission' && items.activities!='GPT Sample Submission' && selected_step_no>30 ">
                  <label v-if="items.status=='Submitted'">
                    <i class="fa fa-check" aria-hidden="true" style="color: #2ECC71">&nbsp;Approved</i>
                  </label>
                  
                </div>

                <div v-if="(items.activities=='FPT Submission' || items.activities=='PP Sample Submission' || items.activities=='GPT Sample Submission') && items.status=='Submitted' && (selected_operational_status!='TNA–uploaded' && selected_operational_status!='TNA_Feedback' && selected_operational_status!='TNA-Rejected' && selected_operational_status!='PO-updated' && selected_operational_status!='POID-Generated' && selected_operational_status!='PO-Submited') && user_type!='Quality_Controller' && user_type!='Brand_Designer'">
                  <label class="radio-inline" ><input type="radio" name="tnaoptradio" value="tnaapproved" v-model="status" checked @click="achivedtnaaction('tnaapproved',items.tna_id,items.activities_id)" >&nbsp;Approve</label>&nbsp;&nbsp;

                   <label class="radio-inline" v-if="items.activities!='Final Inspection'"><input type="radio" name="tnaoptradio" value="conditionalapproved" v-model="status" @click="achivedtnaaction('conditionalapproved',items.tna_id,items.activities_id)" >&nbsp;Partially Approve</label>&nbsp;&nbsp;

                  <label class="radio-inline" ><input type="radio" name="tnaoptradio" value="tnarejected" v-model="status" @click="achivedtnaaction('tnarejected',items.tna_id,items.activities_id)" >&nbsp;Reject</label>
                </div>
                <div v-if="(items.activities=='Final Inspection') && items.status=='Submitted' && (selected_operational_status!='TNA–uploaded' && selected_operational_status!='TNA_Feedback' && selected_operational_status!='TNA-Rejected') && user_type=='Quality_Controller' && user_type!='Brand_Designer'">
                  <label class="radio-inline" ><input type="radio" name="tnaoptradio" value="tnaapproved" v-model="status" checked @click="achivedtnaaction('tnaapproved',items.tna_id,items.activities_id)" >&nbsp;Approve</label>&nbsp;&nbsp;

                   <label class="radio-inline" v-if="items.activities!='Final Inspection'"><input type="radio" name="tnaoptradio" value="conditionalapproved" v-model="status" @click="achivedtnaaction('conditionalapproved',items.tna_id,items.activities_id)" >&nbsp;Partially Approve</label>&nbsp;&nbsp;

                  <label class="radio-inline" ><input type="radio" name="tnaoptradio" value="tnarejected" v-model="status" @click="achivedtnaaction('tnarejected',items.tna_id,items.activities_id)" >&nbsp;Reject</label>
                </div>
              </td>
            </tr>
            
        </tbody>
        
    </table>
  </div>
</b-row>
 <!-- v-if="items.planned_achieve_date !='' && items.planned_approved_flag != 1 && items.planned_action_flag == 0 && items.planned_rejected_flag == 0 " -->

          <b-col md="12" v-if="selected_operational_status =='TNA–uploaded' && ((style_details.assigned_to != null && user_type == 'Junior_Buyer') || (style_details.assigned_to == null && user_type == 'Buyer') || (style_details.assigned_to == null && user_type == 'Brand_Manager') )">
              <b-form  data-vv-scope="form-5" @submit.prevent="updatetnastatus(status)" >
                <b-form-group 
                  label="Action"
                  :label-cols="3" >
                  <b-input-group class="mb-3">

                      <label class="radio-inline"><input type="radio" name="optradio" value="planned_approved" v-model="status" checked @click="opentextfunction('planned_approved')">&nbsp;Approved</label>&nbsp;&nbsp;
                      <!-- <label class="radio-inline"><input type="radio" name="optradio" value="planned_rejected" v-model="status" @click="opentextfunction('planned_rejected')">&nbsp;Reject</label>&nbsp;&nbsp; -->
                      <label class="radio-inline"><input type="radio" name="optradio" value="feedback" v-model="status" @click="opentextfunction('feedback')">&nbsp;Feedback</label>&nbsp;&nbsp;
                      <b-button type="submit" size="sm" class=" text-right" variant="primary">Submit</b-button> 
                      </b-input-group>
                      <div class="text-right">
                       
                       </div>         
                </b-form-group>

              </b-form>
          </b-col>
          <b-col md="12"><br></b-col>
         <!--  </div>
        </div> -->
         <!-- </b-col> -->

            <!-- </div> -->
        </div>

</div>



 </b-row>    



   </div>


 
</template>

<script>

   import CONSTANTS from '@/utils/constants'
   import auth from '@/utils/auth'
   import Vue from 'vue'
   import Router from 'vue-router'
   import Utils from "@/utils";
   import swal from "sweetalert2";

   import sidebarAllDesignsComponent from './_sidebarAllDesignsComponent.vue'
   import navbarMenu from './_navbarMenu.vue'
   
   const axios = require('axios')
   export default {
     name: 'Tabs',
     components: {
        sidebarAllDesignsComponent,
        navbarMenu
      },  

     data () {
       return {
         addfile:false,
         showSideMenu:true,
         items: [],
         result: [],
         style_details:[],
         totalRows: 0,
         outlined:true,
         bordered: true,
         isBusy: false, 
         status_value: '',
         status: '',
         feedback: '',
         fields1: [
               {key: 'buyer_name', label: 'Buyer Name'}, 
               {key: 'vendor_name',label:'Vendor Name'}, 
               {key:'status' , label:'Status' },
               {key:'action' , label:'Action'}
              ],
         file_tab_status: false,
         fileupload_status: false,
         fileObj:[],
         route_id: '',
         selected_vendor_id: 0,
         tnadata: [],
         feedback_arr:[],
         updatetnadetails: false,
         comment: [],
         selectedbuyername: '',
         selectedvendorname:'',
         selectedstatus: '',
         activities: [],
         selected_status: '',
         selected_tna_id: 0,
         selected_activities_id: 0,
         planned_approved_flag: 0,
         selected_tna_id: 0,
         changed_status: '',
         planned_action_flag: 0,
         planned_rejected_flag: 0,
         selected_step_no: 0,
         tna_archivedaction_status: 'nochanged',
         selected_operational_status: '',
        tnafields: [{key: 'activities', label: 'Activities'},
                    {key: 'planned_achieve_date', label: 'Planned Achieve Date'},
                    {key: 'actual_achieved_date',label:'Actual Achieved Date'},
                    
                    {key:'actions' , label:'Action', tdClass: 'commonbtn'}],

        fileData:'',
        extension:'',
        blob:'',
        style_name:"",
        style_code:"",
        designer_name:"",
        buyer_name:"",
        vendor_email:"",
        }  
     },
     created: function() { 
      this.getdesigndetail();
      // this.tnadetails();
      this.route_id=this.$route.params.id;
      var userData = localStorage.getItem('userData');
      var userInfo = JSON.parse(userData);
      this.user_type = userInfo[0].user_type;
      var userData = localStorage.getItem('userData');
      if(userData) 
      {
        this.quote_tab=true;
        this.message_tab=true;
      }
      

     },
       methods: {  
      opentnaModal(value) {
        this.status= '';       
        // this.getdesigndetail();
        this.updatetnadetails =true;
        
 },
        //Function for row data
        getrowdata(value){
          this.selected_tna_id = value.tna_id;
        },
        //Function for row data ends
        //Function for TNA action
        achivedtnaaction: function(status,tna_id,activities_id){
          // alert("In");
          // alert(status);
          this.selected_status=status;
          this.selected_tna_id=tna_id;
          this.selected_activities_id=activities_id;
          var userdata = localStorage.getItem('userData')
          var userInfo = JSON.parse(userdata)

          // if(confirm("Are you sure you want to "+status+"?")){  
            const Obj={
            tna_status: status,
            tna_id: tna_id,
            activities_id: activities_id,
            style_id: this.$route.params.id,
            updated_by: userInfo[0].email_id
          }
          // alert(tna_id);

           

          axios.post(`${CONSTANTS.API_URL}/achivedTNADetailStatus`,Obj)
          .then((result) => {
            document.getElementById("overlay").style.display = "none";
            console.log("SSSSSSSSSSS",result);  
            if(result.data.returnmsg=='Successful'){
              // alert("TNA updated Sucessfully");
              this.$fire({
                      text:" TNA updated Sucessfully.",
                      type: "success",
                      timer: 30000
                            })
              this.tnadetails();
              this.getdesigndetail();
              
              // this.tnadetails();
              // this.getdesigndetail();
            }      
            else{
              // alert(result.body.returnmsg);
              this.$fire({
                      text:result.body.returnmsg,
                      type: "error",
                      timer: 30000
                            })
              this.tna_archivedaction_status = "nochanged";
            }
          })
          .catch((ex) => {
            console.log('error', ex)
          })
          //}
         
          
        },
        //Function for TNA action ends

        //Function for Feedback
        getfeedback: function(index,activities_id,tna_id,comment){
          this.feedback_arr.push({
            feedback: this.comment[index],
            activities_id: activities_id,
            tna_id: tna_id
          });

        },//function ends

        //Function for update TNA status
         updatetnastatus: function (value) {
              
          // document.getElementById("overlay").style.display = "block";
          if(value!='feedback'){
              this.feedback_arr=this.tnadata
          }
          
          var userdata = localStorage.getItem('userData')
          var userInfo = JSON.parse(userdata)
          var recarr=[];

          recarr=this.selectedVendor;
          // const hasBlankFeedback = this.feedback_arr.some((item) => item.feedback.trim() === '');
          // if(hasBlankFeedback){
          // this.$fire({
          // text: 'Please provide valid feedback',
          // type: "error",
          // timer: 30000,
          // });
          // }else{
          const Obj = {
              status: value,
              style_id: this.$route.params.id,
              tna: this.feedback_arr,
              updated_by: userInfo[0].email_id,
              // feedback: this.feedback_arr
          }
          // style_id->143
        //agentmaster
           // return false;
          
        axios.post(`${CONSTANTS.API_URL}/updatetnastatus`,Obj)
          .then((result) => {
            document.getElementById("overlay").style.display = "none";
            console.log("SSSSSSSSSSS",result);  
            if(result.data.returnmsg=='Successful'){
              // alert("TNA updated Sucessfully");
              //  this.$fire({
              //         text:"TNA updated Sucessfully",
              //         type: "success",
              //         timer: 30000
              //               })
             
                let brandName = JSON.parse(localStorage.getItem('selectedBrandId')).target.value.split('+');
                const emailObj = {
                  brand_name: brandName,
                  designer_name: this.designer_name,
                  style_code: this.style_code,
                  style_name: this.style_name,
                  vendor_name: this.selectedvendorname,
                  vendor_email: this.vendor_email,
                  buyer_name: this.buyer_name,
                  value: value,
                  user_id: userInfo[0].user_id,
                }

                console.log("emailobj--------------------------->", emailObj);

                axios
                  .post(`${CONSTANTS.API_URL}/addEmailTriggersDesignIsApproved`, emailObj)
                  .then((response) => {
                    document.getElementById("overlay").style.display = "none";
                    if (response.data.returnmsg === "Successful") {
                      document.getElementById("overlay").style.display = "none";
                      this.$fire({
                        text: "TNA updated Sucessfully and email has been sent to vendor",
                        type: "success",
                        timer: 30000,
                      });
                    }
                    else {
                      this.$fire({
                        text: response.data.returnvalue,
                        type: "danger",
                        timer: 30000,
                      });
                    }
                  })
              

              this.achivedtnaaction(this.selected_status,this.selected_tna_id,
              this.selected_activities_id);
              this.getdesigndetail();
              this.tnadetails();
              
              this.getdesigndetail();
              this.$router.push({ name: 'design_purchaseorder', params: { id: this.route_id } })
              // this.$router.go(0)
              // this.tnadetails();
            }      
            else{
              // alert(result.body.returnmsg);
              this.$fire({
                      text:result.body.returnmsg,
                      type: "error",
                      timer: 30000
                            })
            }
          })
          .catch((ex) => {
            console.log('error', ex)
          })
        // }
        },
        //function ends
        // Function for open txt box for feedback
        opentextfunction: function(value){
          //alert(value);
          this.status_value= value;
          
        },
        //function ends

       /****** Function to design details ********/
       getdesigndetail: function () {
           this.isBusy = true;
       
           const Obj = {
                style_id: this.$route.params.id,              
              }
           axios.post(`${CONSTANTS.API_URL}/getdesigndetail`,Obj)
           .then(response => {
            document.getElementById("overlay").style.display = "none";
             this.result = response.data
             if (this.result.returnmsg === 'Successful') {
              
            this.style_details  = this.result.returnvalue[0];
            this.selected_vendor_id= this.style_details.vendor_id;
            this.selected_operational_status= this.style_details.operational_status;
            this.selectedvendorname = this.style_details.vendor_name;
            this.selectedbuyername = this.style_details.sendqname;
            this.selectedstatus = this.style_details.design_status;
            this.selected_step_no= this.style_details.status_code_number;
            this.totalRows = this.result.returnvalue.length;
            this.style_name = this.style_details.style_name;
            this.style_code = this.style_details.style_code;
            this.designer_name = this.style_details.designer_name;
            this.buyer_name = this.style_details.buyer_name;
            this.vendor_email = this.style_details.vendor_emailId;
            this.sub_catid = this.style_details.sub_catid;
            this.tnadetails(this.sub_catid);
            for(var i=0;i<=this.totalRows;i++){
              if(this.style_details.status_code_number>=8){
                this.file_tab_status =true;
                
              }
            }
            }

           })
           .catch(e => {
             this.errors.push(e)
           })
   
   
       },

         tnadetails: function(subcat_id) {
      var userData = localStorage.getItem('userData');
           var userInfo = JSON.parse(userData)
      const Obj = {

               vendor_id:this.selected_vendor_id,
               // vendor_id: 401,
                 style_id:this.$route.params.id,
                 subcat_id: subcat_id,
                 operational_status:  this.selected_operational_status
                  }
              axios.post(`${CONSTANTS.API_URL}/getTNADetails`,Obj)
                .then(response => {
                  this.result = response.data
                  this.tnadata = response.data.returnvalue;
                  if (this.result.returnmsg === 'Successful') {
                    this.result = this.result.returnvalue;
                    // for(var i=0;i<=this.result.length;i++){

                    //   if(this.result[i].planned_achieve_date==''){
                        
                    //     this.planned_action_flag=1;
                    //   }
                    //   if(this.result.returnvalue[i].status=='planned_approved' || this.result.returnvalue[i].status=='feedback'){
                    //     this.planned_approved_flag=1;
                    //   }
                    // }
                    // this.tnadata = this.result.returnvalue;
                    
                    for(var i=0;i<=this.tnadata.length-1;i++){
                      
                      if(this.tnadata[i].planned_achieve_date==''){
                        
                        this.planned_action_flag=1;
                      }
                      if(this.tnadata[i].status=='planned_approved' || this.tnadata[i].status=='feedback'){
                        this.planned_approved_flag=1;

                      }
                      if(this.tnadata[i].status=='planned_rejected'){
                        this.planned_rejected_flag=1;
                      }
                      if(this.tnadata[i].status=='Updated' && this.tnadata[i].previous_planned_date){
                        this.tnadata[i].planned_achieve_date =  this.tnadata[i].previous_planned_date
                      }
                    }
                   
                    for(var i=0;i<this.tnadata.length;i++){
                      this.comment[i]=this.tnadata[i].feedback;
                    }

                    let  sortedArray = ['CURRENT STATUS', 'FABRIC MILL', 'GREIGE BOOKING', 'LD/STRIKE OFF/DL DATE', 'Fabric Approval date','Fabric Order Date', 'FABRIC STATUS', 'FPT Report', 'Fabric Inhouse', 'PP Sample Submission', 'GPT Report Submission', 'PRODUCTION START DATE', 'Cutting', 'Sewing', 'Finishing', 'Packaging', 'Final Inspection', 'EX FTY DISPATCH DATE', 'Dispatch', 'IN-TRANSIT/DISPATCH', 'PLANNED INWARD MONTH', 'ACTUAL INWARD MONTH', 'PLN W/H INWARD WEEK', 'ACTUAL INWARD WEEK', 'ACTUAL INWARD DATE', 'Delivery Date', 'REASON OF DELAY','Material approved date ','Material Order date ','Lasting ','Material status','Material inhouse','PP Sample submission','Production start date','Upper & Insole making','Lasting','Pasting','Packing','Test Report Submission','Final inspection','Ex FTY Dispatch Date','In transit','Planned inward Month','Actual inward Month','Planned Inward Week','Actual inward Week','Delivery date']
                    const sortedData = sortedArray.map(title => this.result.returnvalue.find(obj => obj.activities === title));
                    this.tnadata = sortedData.filter(value => value !== undefined);
                    this.isBusy = !this.isBusy;
                  }
                  else
                  {
                    this.tnadata = this.result.returnvalue;
                    this.isBusy = !this.isBusy;
                  }


                })
                // .catch(e => {
                //   this.errors.push(e)
                // })

    }, 

        tnadownload:function(tna_id){
      // alert()
      document.getElementById("overlay").style.display = "block";
      const Obj = {
        tna_id: tna_id
      }
      
        axios
          .post(`${CONSTANTS.API_URL}/downloadTNAFiles`, Obj)
          .then((response) => {
            document.getElementById("overlay").style.display = "none";
            if(response.data.result === "success")
            {
              this.fileData = response.data.data
              this.extension = response.data.extension

              // // Create a new Uint8Array from the buffer data
              console.log('this.extension------------------------------------->')
              console.log(this.extension)

              const uint8Array = new Uint8Array(this.fileData.data);

              // // Create a Blob object from the Uint8Array
              if(this.extension === 'png')
              {
                 this.blob = new Blob([uint8Array], { type: `image/png` });
              }else if(this.extension === 'jpeg')
              {
                 this.blob = new Blob([uint8Array], { type: `image/jpeg` });
              }
              else if(this.extension === 'jpg')
              {
                 this.blob = new Blob([uint8Array], { type: `image/jpg` });
              }
              else if(this.extension == 'pdf')
              {
                 this.blob = new Blob([uint8Array], { type: `application/pdf` });
              }
               else if(this.extension == 'csv')
              {
                 this.blob = new Blob([uint8Array], { type: `text/csv` });
              }
              else if(this.extension == 'xlsx')
              {
                 this.blob = new Blob([uint8Array], { type: `application/vnd.openxmlformats-officedocument.spreadsheetml.sheet` });
              }else{
                this.$fire({
                  text: "Please select correct file and try again!",
                  type: "warning",
                  timer: 30000,
                });
              }



             
              console.log('blob------------------------------------->')
              console.log(this.blob)
              // Create a DOMString representing the blob URL

              let patternImageUrl = URL.createObjectURL(this.blob);
              console.log('patternimage url--------------------->')
              console.log(patternImageUrl)
              var downloadLink = document.createElement("a");

                downloadLink.href = patternImageUrl;
                downloadLink.download = "sample_image";
                document.body.appendChild(downloadLink);
                downloadLink.click();
                document.body.removeChild(downloadLink);
              

            }
          })
          
    },


        onClose() {
            this.visible = false;
        },

     }
   };
</script>
<style>
   .short-div {
   height:55px;
   }


.quote-dropdowns .dropdown--accepted {
    border-top: 1px solid var(--fill-green-dark);
}

.quote-dropdowns>.card {
    background-color: var(--fill-white);
}
.quote-dropdowns .dropdown__header.dropdown__header--accepted {
    border: 1px solid var(--fill-green-dark);
    border-top: none;
    background-color: #e8fff5;
}
.card .card__section {
    flex-grow: 1;
    box-shadow: inset 0 -1px 0 0 #e5e5e5;
    box-shadow: inset 0 -1px 0 0 var(--fill-grey-light3);
}
.quote-dropdowns .dropdown__header {
    align-items: center;
    justify-items: center;
    justify-content: center;
    cursor: pointer;
}
.quote-dropdowns .card__section {
    padding: 16px 32px;
}
.f-sz-l {
    font-size: 15px;
}
.flex-col {
    flex-direction: column;
}
.flex, .flex-col {
    display: flex;
}
.f-w-semi-bold {
    font-weight: 600;
}
.f-sz-sm {
    font-size: 12px;
}
.f-w-semi-bold {
    font-weight: 600;
}   

.card .card__section {
    flex-grow: 1;
    box-shadow: inset 0 -1px 0 0 #e5e5e5;
    box-shadow: inset 0 -1px 0 0 var(--fill-grey-light3);
}
.quote-dropdowns .card__section {
    padding: 16px 32px;
}

.input-grp {
    width: 100%;
    margin-bottom: 16px;
}
.input-grp {
    margin-bottom: 10px!important;
}

.input-grp label {
    margin-bottom: 6px;
    color: #333340;
}

input[type=number], input[type=password], input[type=tel], input[type=text] {
    padding: 13px 12px;
    border-radius: 2px;
    border: 1px solid #bfbfbf;
}
.input-grp input, .input-grp label, .input-grp select {
    display: block;
    width: 100%;
}

.input-grp select:disabled {
    background-color: #ebebe4;
}
.input-grp select {
    background: url(/static/media/ic-arrow-drop-down.1f6abe65.svg) no-repeat;
    background-position: right 8px top 6px;
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
}

.quote-dropdowns .dropdown__header.dropdown__header--accepted {
    border: 1px solid var(--fill-green-dark);
    border-top: none;
    background-color: #e8fff5;
}

  .brand-card{
   border-radius:0px !important;
  }

     .sidebar{
   background: #17a2b8!important;
   width:50px !important;
   }

   .sidebar .sidebar-nav{
    width:50px !important;
   }
   .sidebar .nav{
    width:50px !important;
   }

   .main{
    margin-left:50px !important;
   }
   #rec_msg{    
    margin-left: 40%;
    position: absolute;
   }


/*** Tabb ***/
.header-tabs__navbar {
    margin-top: auto;
    align-items: center;
    border-top: 1px solid var(--fill-grey-light2);
}
.flex {
    display: flex;
}

.header-tabs__tab {
    position: relative;
    flex: 1 1;
    height: 43px !important;
    padding: 12px 22px;
    border-bottom: 3px solid var(--fill-grey-light3);
    display: flex;
    flex-direction: row;
    cursor: pointer;
    border: 1px solid #63c2de;
    border-radius: 12px;
}

.header-tabs__tab-image {
    padding-right: 8px;
}

.header-tabs__tab-block {
    display: flex;
    flex-direction: column;
    justify-content: center;
}
 
.header-tabs__tab .sub_title {
    font-size: 12px;
    line-height: 16px;
    text-transform: capitalize;
    font-weight: 400;
    color: var(--fill-grey-medium);
} 



html, body {
  margin: 0
}
.wrapper {
  display: flex;
  flex-direction: column;
  height: 92vh;
  width: 100%;
  background-color:white
}

/*Todays CSS*/
.nav_row_tabs {
 
  display: flex;
  border-top: 1px solid #D7DBDD;
  border-bottom: 1px solid #D7DBDD;
}

  #activeTitle{
  font-size: 14px;
}
.t_cell{
  word-wrap: break-word; 
  column-width: fixed;
  max-width: 250px !important;
}
.commonbtn{
  align-items: center;
  ​rowspan:2;
  max-width: 200px;

}
.btn_download{
  background: none;
}
@media (max-width: 1040px)
{
 .tnaside{
  display:none;
 }
}
@media (max-width: 450px) and (min-width: 380px)
{
 .theader{
  font-size:10px;
 }
 .tdactivities{
  font-size: 10px;
 }
 .tdplanneddate{
  font-size: 10px;
 }
 .tdactualdate{
  font-size: 10px;
 }
  .tdfeedback{
  font-size: 10px;
 }
   .tdtnafeedback{
  font-size: 10px;
 }
  .tddownload{
  font-size: 10px;
 }
  .tdtnastatus{
  font-size: 10px;
 }
  .tnapocol{
  margin-left: -18px;
 }
}
@media (max-width: 375px)
{
 .theader{
  font-size:10px;
 }
 .tdactivities{
  font-size: 10px;
  width:10px;
 }
 .tdplanneddate{
  font-size: 10px;
  width:5px;
 }
 .tdactualdate{
  font-size: 10px;
   width:5px;
 }
  .tdfeedback{
  font-size: 10px;
  width:5px;
 }
   .tdtnafeedback{
  font-size: 10px;
  width: 5px;
 }
  .tddownload{
  font-size: 10px;
 }
  .tdtnastatus{
  font-size: 10px;
  width: 10px;
 }
 .tnapocol{
  margin-left: -18px;
 }
}
@media (max-width: 340px) 
{
 .theader{
  font-size:9px;
 }
 .tdactivities{
  font-size: 9px;
  width:10px;
 }
 .tdplanneddate{
  font-size: 9px;
  width:5px;
 }
 .tdactualdate{
  font-size: 9px;
   width:5px;
 }
  .tdfeedback{
  font-size: 9px;
  width:5px;
 }
   .tdtnafeedback{
  font-size: 9px;
  width: 5px;
 }
  .tddownload{
  font-size: 9px;
 }
  .tdtnastatus{
  font-size: 9px;
  width: 10px;
 }
 .tnapocol{
  margin-left: -18px;
 }
}
</style>
